import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { Table } from '../../../elements/table';
import { useDrawer } from '../../../shared/drawer';
import { useStore } from '../../../shared/store';
import { useHttpClient } from '../../../shared/http-client';
import { CheckIcon, XIcon } from '@heroicons/react/outline';
import { ConductoresFilter } from '../conductores/conductores-filter';
import { Button } from '../../../elements/button';
import { FilterIcon } from '../../../../assets/icons/FilterIcon';
import { RenderFilters } from '../../../elements/render-filters';
import { VehiculosFilter } from '../vehiculos/vehiculos-filter';
import { TableFilter } from '../../../elements/table-filter';

export const AsignacionesCreate = () => {

    const { t } = useTranslation() as { t: (key: string) => string };
    const navigate = useNavigate();
    const { open, close } = useDrawer();
    const { get, set } = useStore();
    const { api, state } = useHttpClient();
    const [step, setStep] = useState<string | null>('1');
    const [filtersConductor, setFiltersConductor] = useState<any>({});
    const [filtersVehiculo, setFiltersVehiculo] = useState<any>({});
    const [conductor, setConductor] = useState<any | null>({});
    const [queryConductor, setQueryConductor] = useState<string>('');
    const [vehiculoState, setVehiculoState] = useState<{ filtros: any; page: number }>({ filtros: {}, page: 0 });
    const [queryVehiculo, setQueryVehiculo] = useState<string>('');
    const [vehiculo, setVehiculo] = useState<any | null>({});
    const [pageVehiculo, setPageVehiculo] = useState<number>(1);
    const [pageConductor, setPageConductor] = useState<number>(1);
    const [conductorState, setConductorState] = useState<{ filtros: any; page: number }>({ filtros: {}, page: 0 });

    const [date, setDate] = useState<string>(dayjs().format('YYYY-MM-DDTHH:mm:ss'));

    const initialValues = {
        assignment_datetime: dayjs().format('YYYY-MM-DDTHH:mm:ss')
    };

    let obligado = {
        //assignment_datetime: Yup.string().required('obligatorio'),
    };

    const validacion = Yup.object().shape(obligado);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;

        setDate(value);

    };


    const handleSelectConductor = (item: any) => {
        setConductor(item);
        setStep('2');
        set('idConductor', item.id);
    };

    const handleSelectVehiculo = (item: any) => {
        setVehiculo(item);
        setStep('4');
    };

    const handleFiltersConductor = () => {
        open(
            'common.filter.title',
            <ConductoresFilter close={close} doFilter={(filtersConductor: any) => doFilterConductor(filtersConductor)} item={conductorState.filtros} />
        );
    };

    const doFilterConductor = (filtersConductor: any) => {
        console.log('filtersConductor', filtersConductor)
        close();
        setConductorState({ filtros: filtersConductor, page: 0 });
    };

    useEffect(() => {
        const params = new URLSearchParams(conductorState.filtros);
        params.set('offset', String(conductorState.page));
        setQueryConductor(params.toString());
    }, [conductorState]);

    const handleFiltersVehiculo = () => {
        open(
            'common.filter.title',
            <VehiculosFilter close={close} doFilter={doFilterVehiculo} item={vehiculoState.filtros} />
        );
    };

    const doFilterVehiculo = (filtersVehiculo: any) => {
        console.log('filtersVehiculo', filtersVehiculo)
        close();
        setVehiculoState({ filtros: filtersVehiculo, page: 0 });
    };

    useEffect(() => {
        const params = new URLSearchParams(vehiculoState.filtros);
        params.set('offset', String(vehiculoState.page));
        setQueryVehiculo(params.toString());
    }, [vehiculoState]);

    const beforeSubmit = (values: any | null) => {
        let after = { ...values };

        after.vehicle = vehiculo.id;
        after.driver = conductor.id;

        const formattedDate = date ? new Date(new Date(date).getTime() - new Date(date).getTimezoneOffset() * 60000).toISOString().slice(0, 16) : "";

        after.assignment_datetime = date || formattedDate;

        return after;
    };

    const onSubmit = async (values: any | null) => {
        //
        const enviaremos = beforeSubmit(values);
        // create
        api('/fleet/assignments/assign/', 'POST', enviaremos);

    };


    useEffect(() => {
        if (state.data) {
            if (state.path.includes('assignments')) {
                if (state.method === 'POST') {
                    toast.success(`${t('common.label.asignacion-existosa')}`);
                    navigate('/assignments/');
                }
            }
        }

        if (state.error) {
            toast.error('Server Error');
        }
    }, [state]);


    return (
        <>
            <div
                className="pt-8 pl-8 cursor-pointer"
                onClick={() => {
                    if (step === '3') {
                        setStep('2');
                    } else {
                        navigate(-1);
                    }
                }}
            >
                <span className='text-black pt-[5px]'>{'< '}</span>
                <span className='text-black text-[12px]'>{t('common.button.back')}</span>
            </div>

            {step === '1' ? <div className='p-8'>
                <div className='text-[18px] text-gray-900 pb-8'>{t('common.label.select-conductor')}</div>
                <div> <Button
                    dataTestId="filter-action"
                    variant={`transparent`}
                    outlined
                    label={t('common.label.filtrar')}
                    onClick={handleFiltersConductor}
                    icon={
                        <FilterIcon />
                    }
                /></div>
                <div>{Object.keys(filtersConductor).length > 0 ? (
                    <RenderFilters filters={conductorState.filtros} />
                ) : (
                    ''
                )}</div>
                <TableFilter
                    path="/fleet/drivers/"
                    withPagination
                    query={queryConductor}
                    page={pageConductor}
                    onPageChange={setPageConductor}
                    onSelection={handleSelectConductor}
                    noEdit={true}
                    noDelete={true}
                    headers={[
                        {
                            key: 'identification_number',
                            label: 'common.label.nif-nie'
                        },
                        {
                            key: 'full_name',
                            label: 'common.label.name'
                        },
                        {
                            key: 'driving_license_expiration',
                            type: 'date',
                            label: 'common.label.caducidad-carnet',
                        },
                        {
                            key: 'available',
                            type: 'boolean',
                            label: 'common.form-label.disponible',
                        },
                        {
                            key: 'status',
                            type: 'status',
                            label: 'common.label.estado',
                        },
                        {
                            key: 'photo_display_url',
                            type: 'image',
                            label: 'common.form-label.foto',
                        },
                    ]}
                />
            </div> : ''}
            {step === '2' ?
                <div className='h-1/2 p-8 flex items-center justify-center'>
                    <div className='flex flex-col justify-center '>
                        {conductor.photo_display_url ? <div className='flex justify-center'>
                            <img
                                className="h-40 w-auto"
                                src={conductor.photo_display_url}
                            />
                        </div> : ''}
                        <div className='flex justify-center'>
                            <div className='flex pt-4'>
                                <div className='flex justify-center '>{conductor.full_name}</div>
                                <div className='pl-2 pt-[1px]'>{conductor.disponible ? <CheckIcon
                                    className={
                                        'h-5 w-5 p-1 text-white rounded-full bg-green-400'
                                    }
                                /> : <XIcon
                                    className={
                                        'h-5 w-5 p-1 text-white rounded-full bg-red-600'
                                    }
                                />}</div>
                            </div>
                        </div>

                        <div className='flex w-full h-40 justify-center pt-4'>
                            <div className='flex justify-center items-center border border-gray-400 rounded-lg p-4 w-64 mr-2 bg-green-500  font-semibold text-white cursor-pointer' onClick={() => setStep('3')}>{t('common.label.recoger-vehiculo')}</div>
                            <div className='flex justify-center items-center border border-gray-400 rounded-lg p-4  w-64 ml-2 bg-red-500 font-semibold text-white cursor-pointer' onClick={() => navigate(`/assignments/release/`)} >{t('common.label.devolver-vehiculo')}</div>
                        </div>
                    </div>

                </div>
                : ''}
            {step === '3' ?
                <div className='p-8'>
                    <div className='text-[18px] text-gray-900 pb-8'>{t('common.label.select-vehiculo')}</div>
                    <div> <Button
                        dataTestId="filter-action"
                        variant={`transparent`}
                        outlined
                        label={t('common.label.filtrar')}
                        onClick={handleFiltersVehiculo}
                        icon={
                            <FilterIcon />
                        }
                    /></div>
                    <div>{Object.keys(filtersVehiculo).length > 0 ? (
                          <RenderFilters filters={vehiculoState.filtros} />
                    ) : (
                        ''
                    )}</div>
                    <TableFilter
                        path="/fleet/vehicles/"
                        withPagination
                        query={queryVehiculo}
                        page={pageVehiculo}
                        onPageChange={setPageVehiculo}
                        onSelection={handleSelectVehiculo}
                        isVehicle={true}
                        noEdit={true}
                        noDelete={true}
                        headers={[
                            {
                                key: 'plate',
                                label: 'common.form-label.matricula'
                            },
                            {
                                key: 'available',
                                type: 'boolean',
                                label: 'common.form-label.disponible',
                            },
                            {
                                key: 'status',
                                type: 'status',
                                label: 'common.label.estado',
                            },
                            {
                                key: 'photo_display_url',
                                type: 'image',
                                label: 'common.form-label.foto',
                            },
                        ]}
                    />

                </div>
                : ''}
            {step === '4' ? <div>
                <div className='flex p-8 mt-24'>
                    <div className='flex'>
                        {vehiculo?.photo_display_url ? <img className='h-[180px] pb-4 pr-4' src={vehiculo?.photo_display_url} /> : ''}
                        {conductor?.photo_display_url ? <img className='h-[180px] pb-4 pr-4' src={conductor?.photo_display_url} /> : ''}
                    </div>
                    <div className='pl-8'>
                        <div className='flex'>
                            <div className="text-[20px]  text-gray-900 pr-4">
                                {t('common.label.vehiculo')}:
                            </div>
                            <div className="text-[20px]  text-gray-900 pr-4 font-semibold">
                                {vehiculo?.plate}
                            </div>
                        </div>
                        <div className='flex'>
                            <div className="text-[20px]  text-gray-900 pr-4">
                                {t('common.label.conductor')}:
                            </div>
                            <div className="text-[20px]  text-gray-900 pr-4 font-semibold">
                                {conductor?.full_name}
                            </div>
                        </div>
                        <div className="w-full">
                            <Formik
                                enableReinitialize={true}
                                initialValues={initialValues}
                                validationSchema={validacion}
                                validateOnBlur={true}
                                onSubmit={onSubmit}
                            >
                                {({
                                    values,
                                    errors,
                                    touched,
                                    setFieldValue,
                                    handleSubmit,
                                    isSubmitting
                                }) => (
                                    <form onSubmit={handleSubmit} autoComplete="off">
                                        <div className="flex">
                                            <div className="w-full">
                                                <div className="my-[11px] w-full">



                                                    {/* --------------------FECHA------------------- */}

                                                    {/*   <DatePicker
                                                        name="assignment_datetime"
                                                        type="date"
                                                        label={t('common.label.fecha-asignacion')}
                                                        value={dayjs().format('YYYY-MM-DD') || values.assignment_datetime}
                                                        onChange={(value: any) => {
                                                            setFieldValue(
                                                                'assignment_datetime',
                                                                value.assignment_datetime
                                                                    ? dayjs(value.assignment_datetime).format(
                                                                        'YYYY-MM-DD'
                                                                    )
                                                                    : null
                                                            );
                                                        }}
                                                    />
                                                    <FieldError touched={touched} errors={errors} field={"assignment_datetime"} /> */}
                                                    {/* --------------------FECHA------------------- */}
                                                    <div className="my-[11px] w-full">
                                                        {/* --------------------FECHA------------------- */}

                                                        <label className="block text-sm font-semibold leading-6 text-gray-700">
                                                            {t('common.label.fecha-asignacion')}
                                                        </label>
                                                        <input
                                                            id="dateInput"
                                                            type="datetime-local"
                                                            step="1" // Permite solo minutos (sin segundos)
                                                            value={date} // Mostrar sin segundos en el input
                                                            onChange={handleChange}
                                                        />
                                                    </div>


                                                </div>

                                            </div>
                                        </div>
                                        <div>
                                            <Button
                                                onClick={handleSubmit}
                                                label={t('common.label.asignar')}
                                            />
                                        </div>
                                    </form>
                                )}
                            </Formik>
                        </div>
                    </div>

                </div>


            </div> : ''}

        </>

    );
};